import { render, staticRenderFns } from "./DeliveryGetNotasEmAtrasoListView.vue?vue&type=template&id=65789589&scoped=true"
import script from "./DeliveryGetNotasEmAtrasoListView.vue?vue&type=script&lang=ts"
export * from "./DeliveryGetNotasEmAtrasoListView.vue?vue&type=script&lang=ts"
import style0 from "./DeliveryGetNotasEmAtrasoListView.vue?vue&type=style&index=0&id=65789589&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../local-cache/custom/dba27c31aad935787bb275c3e5e4e957708f15386de599eff1db476022cd7e4c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65789589",
  null
  
)

export default component.exports